import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useStudentAuth } from "../../context/StudentAuthContext";
import logo from "../../assets/logo.png";

export default function PublicNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [loginMenuOpen, setLoginMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const { isAuthenticated, account, logout } = useStudentAuth();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    function onClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) setLoginMenuOpen(false);
    }
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  return (
    <motion.header
      className={`pm-nav ${scrolled ? "pm-nav--scrolled" : ""}`}
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="pm-nav__inner">
        <Link to="/" className="pm-nav__brand">
          <img src={logo} alt="Positive Moves" className="pm-brand-logo" />
        </Link>

        <nav className="pm-nav__links">
          <a href="#about">About</a>
          <a href="#opportunities">Campuses</a>
          <a href="#process">Process</a>
        </nav>

        <div className="pm-nav__actions">
          <div className="pm-login-menu" ref={menuRef}>
            <button
              className="pm-btn pm-btn--outline pm-btn--sm"
              onClick={() => setLoginMenuOpen((v) => !v)}
            >
              {isAuthenticated ? account?.full_name?.split(" ")[0] : "Log in"} ▾
            </button>

            <AnimatePresence>
              {loginMenuOpen && (
                <motion.div
                  className="pm-login-menu__dropdown"
                  initial={{ opacity: 0, y: -6, scale: 0.98 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: -6, scale: 0.98 }}
                  transition={{ duration: 0.16 }}
                >
                  {isAuthenticated ? (
                    <>
                      <NavLink to="/student/dashboard" onClick={() => setLoginMenuOpen(false)}>
                        My applications
                      </NavLink>

                      <NavLink to="#" onClick={() => {setLoginMenuOpen(false); logout();}}>
                        Logout
                      </NavLink>
                    </>
                    
                  ) : (
                    <NavLink to="/student/login" onClick={() => setLoginMenuOpen(false)}>
                      Student login
                    </NavLink>
                  )}
                  <NavLink to="/panel/login" onClick={() => setLoginMenuOpen(false)}>
                    Panel login
                  </NavLink>
                  <NavLink to="/admin/login" onClick={() => setLoginMenuOpen(false)}>
                    Admin login
                  </NavLink>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          {isAuthenticated ? (
            <a href="#apply" className="pm-btn pm-btn--primary pm-btn--sm">Apply now</a>
          ) : (
            <Link to="/student/signup" className="pm-btn pm-btn--primary pm-btn--sm">Apply now</Link>
          )}
        </div>
      </div>
    </motion.header>
  );
}